var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeedtestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 46,
    viewBox: "0 0 79 46",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_883)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.810326 38.8C-0.0892352 28.9897 4.6131 14.0128 18.8356 5.42876C32.7665 -2.98036 49.5268 -0.635415 59.5318 6.40326C58.6474 7.10482 57.7838 7.79101 56.9202 8.47335C55.3029 9.74961 53.6648 11.0009 52.074 12.3098C51.5191 12.7673 51.1308 12.7615 50.5267 12.3656C45.5536 9.09995 40.0539 7.40467 34.1642 7.46425C21.9282 7.58534 12.533 13.0998 5.91415 23.4829C3.56772 27.1656 1.63224 31.8036 0.810326 38.8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5389 39.6497C78.2529 39.6709 77.9461 39.7074 77.6393 39.7112C73.4786 39.7612 69.316 39.792 65.1553 39.8669C64.4243 39.8804 64.1648 39.7093 64.2046 38.9097C64.6212 30.8427 62.0419 23.8387 56.8604 17.7649C56.6748 17.5477 56.5631 17.0249 56.6918 16.8134C58.4076 13.9841 60.1727 11.1836 61.9301 8.3774C61.9756 8.30436 62.0703 8.26015 62.1347 8.20825C70.1985 12.3888 79.8759 30.885 78.5389 39.6497Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.9698 9.54992C57.4945 11.9256 56.023 14.3052 54.5459 16.6789C49.7848 24.3308 45.02 31.9787 40.2703 39.6363C39.9389 40.1707 39.7097 40.7723 39.4465 41.3489C38.1132 44.2685 35.1324 46.0042 32.1704 45.5813C28.9055 45.1162 26.4341 42.7174 25.9341 39.5268C25.4398 36.3784 27.0856 33.2915 29.9547 31.8557C30.6516 31.5078 31.2766 30.9965 31.8977 30.5103C40.6509 23.6465 49.3966 16.7731 58.146 9.90358C58.3676 9.72867 58.6005 9.57106 58.8297 9.40576C58.877 9.45381 58.9244 9.50187 58.9717 9.55184L58.9698 9.54992ZM30.1441 38.091C30.1516 39.8266 31.5057 41.2028 33.1988 41.199C34.8672 41.1951 36.2668 39.7613 36.2554 38.0698C36.244 36.3361 34.8843 34.9676 33.1799 34.9733C31.4678 34.9791 30.1346 36.3457 30.1422 38.091H30.1441Z",
    fill: "#fff",
    style: {
      animation: "swing2 3s infinite",
      transformOrigin: "center bottom"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.9588,
    height: 45.5861,
    fill: "white",
    transform: "translate(0.705078 0.0566406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedtestIcon);
export default __webpack_public_path__ + "static/media/speedtest-icon.dad6b72a08cb9f5535ee579a042a2b7e.svg";
export { ForwardRef as ReactComponent };